import { Suspense } from 'react'

import { cn } from '#/shared/lib/utils'
import { lazyNamed } from '#/shared/lib/version-check'

const LazyRichText = lazyNamed(
  () => import('./rich-text'),
  (m) => m.RichText,
)

interface RichTextProps {
  html: string
  className?: string
}

export function RichText(props: RichTextProps) {
  return (
    <Suspense
      fallback={
        <div
          className={cn(
            'h-4 w-full animate-pulse rounded bg-gray-100',
            props.className,
          )}
        />
      }
    >
      <LazyRichText {...props} />
    </Suspense>
  )
}
